import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "version-display"
}
const _hoisted_2 = {
  key: 0,
  class: "version-badge"
}
const _hoisted_3 = {
  key: 1,
  class: "version-text"
}

import { ref, onMounted } from "vue";
import axios from "axios";


export default /*@__PURE__*/_defineComponent({
  __name: 'VersionDisplay',
  props: {
    displayMode: {}
  },
  setup(__props: any) {



const version = ref<string>("");
const loading = ref<boolean>(true);

const webVersion = process.env.VUE_APP_WEB_VERSION;

let postUrl = "";

if (process.env.NODE_ENV === "development") {
  postUrl = process.env.VUE_APP_LOCAL_URL;
}

onMounted(async () => {
  try {
    const response = await axios.get(postUrl + "/api/version/");
    version.value = response.data.version;
  } catch (error) {
    console.error("Failed to fetch version:", error);
    version.value = "unknown";
  } finally {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (!loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.displayMode === 'badge')
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, " v" + _toDisplayString(version.value), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, " PICNIC API version " + _toDisplayString(version.value) + ", release " + _toDisplayString(_unref(webVersion)), 1))
      ]))
    : _createCommentVNode("", true)
}
}

})